import clsx from 'clsx';
import * as Styled from './IconStatusWrapper.styles';
import type { IconStatusWrapperProps } from './types';

const IconStatusWrapper = (props: IconStatusWrapperProps) => {
  const {
    className,
    color,
    IconComponent,
    invertColors = false,
    variant,
    size = 'default',
    ...otherProps
  } = props || {};

  return (
    <Styled.Wrapper
      className={clsx(className, {
        [`icon-${size}`]: size,
      })}
      color={color}
      invertColors={invertColors}
      size={size}
      variant={variant}
    >
      <IconComponent color={!invertColors ? color : undefined} {...otherProps} />
    </Styled.Wrapper>
  );
};

export default IconStatusWrapper;
